import * as React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import LoginPage from "pages/login"
import Register from "pages/login/Register"
import ThankYou from "pages/login/ThankYou"

const PageRoutes = () => {
  return (
    <Routes>

      <Route path="/register" element={<Register></Register>} />\
      <Route path="/thank-you" element={<ThankYou></ThankYou>} />
      <Route path="*" element={<LoginPage></LoginPage>} />
    </Routes>
  );
};

export default React.memo(PageRoutes);
